import { formatPrice } from '../utils/helpers';

export const discountPct = (price, compare) =>
  compare && price && Number(compare) > Number(price) ? Math.round(((compare - price) / compare) * 100) : 0;

export const productCompare = (p) => p?.compare_at_price ?? p?.original_price ?? p?.originalPrice ?? null;

// Lowest price in stock; if all prices equal, first variant with stock
export const pickDefaultVariant = (variants = []) => {
  const inStock = variants.filter(v => Number(v.stock) > 0);
  const pool = inStock.length ? inStock : variants;
  if (!pool.length) return null;
  const min = Math.min(...pool.map(v => Number(v.price) || Infinity));
  return pool.find(v => Number(v.price) === min) || pool[0];
};

export const PriceBlock = ({ price, compare, size = 'md', testid }) => {
  const off = discountPct(price, compare);
  const big = size === 'lg' ? 'text-3xl lg:text-4xl' : size === 'sm' ? 'text-xl' : 'text-2xl';
  return (
    <div data-testid={testid}>
      {off > 0 && (
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-400 line-through" data-testid={testid ? `${testid}-compare` : undefined}>{formatPrice(compare)}</span>
          <span className="text-xs font-bold text-red-600">-{off}%</span>
        </div>
      )}
      <p className={`${big} font-semibold text-gray-900`}>{formatPrice(price)}</p>
    </div>
  );
};
